import { SnackbarProvider } from "notistack";
import React, { Component } from "react";
import { MyLoadingIndicator } from "../components/my-loading-indicator/MyLoadingIndicator";
import { SnackbarUtilsConfigurator } from "../SnackbarUtils";
import { BusThemeProvider } from "./BusThemeProvider";

export class BusLayout extends Component {
  static displayName = BusLayout.name;

  render() {
    return (
      <BusThemeProvider>
        <SnackbarProvider>
          <SnackbarUtilsConfigurator />
          {this.props.children}
        </SnackbarProvider>
        <MyLoadingIndicator />
      </BusThemeProvider>
    );
  }
}
